import { render, staticRenderFns } from "./DetailLeftForm.vue?vue&type=template&id=9b1d7a96&scoped=true&"
import script from "./DetailLeftForm.vue?vue&type=script&lang=js&"
export * from "./DetailLeftForm.vue?vue&type=script&lang=js&"
import style0 from "./DetailLeftForm.vue?vue&type=style&index=0&id=9b1d7a96&prod&lang=scss&scoped=true&"
import style1 from "./DetailLeftForm.vue?vue&type=style&index=1&id=9b1d7a96&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b1d7a96",
  null
  
)

export default component.exports